import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';   // adjust path if needed

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar fade-in">
      <div className="navbar-brand">
        <span>CrossBorderPay</span>
      </div>
      <div className="navbar-links">
        {user && (
          <>
            <span className="wallet-info">
              {user.role === 'passenger' && `$${Number(user.wallet_balance || 0).toFixed(2)}`}
            </span>
            <span className="user-name">{user.fullname}</span>
            <button onClick={handleLogout} className="btn btn-outline">Logout</button>
          </>
        )}
      </div>

      <style>{`
        .navbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 2rem;
          background: var(--surface);
          box-shadow: var(--shadow-sm);
          position: sticky;
          top: 0;
          z-index: 100;
          flex-wrap: wrap;
        }
        .navbar-brand {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 700;
          font-size: 1.25rem;
          color: var(--primary);
        }
        .nav-logo { height: 32px; }
        .navbar-links {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        .wallet-info {
          background: var(--primary-light);
          color: var(--primary);
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-weight: 600;
        }
        .user-name { font-weight: 500; }

        /* ---------- Mobile & Tablet ---------- */
        @media (max-width: 768px) {
          .navbar {
            flex-direction: column;        /* stack brand & links vertically */
            padding: 0.75rem 1rem;
            gap: 0.5rem;
          }
          .navbar-brand {
            width: 100%;
            justify-content: center;       /* center the brand */
            font-size: 1.2rem;
          }
          .navbar-links {
            width: 100%;
            justify-content: center;       /* center user info row */
            gap: 0.75rem;
            flex-wrap: wrap;
          }
          .wallet-info {
            font-size: 0.85rem;
            padding: 0.2rem 0.5rem;
          }
          .user-name {
            font-size: 0.85rem;
          }
          .btn-outline {
            padding: 0.35rem 0.75rem;
            font-size: 0.85rem;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;